import { render } from "./size-guide-drawer.vue?vue&type=template&id=130540bc"
import script from "./size-guide-drawer.vue?vue&type=script&lang=js"
export * from "./size-guide-drawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__